interface Props {
  onStartFree: () => void;
  onGoPro: () => void;
}

export function DataNoticeScreen({ onStartFree, onGoPro }: Props) {
  return (
    <div className="data-notice">
      <div className="data-notice__card">
        <header className="data-notice__head">
          <div className="data-notice__eyebrow">Before you begin</div>
          <h1>Orchestration Coach is free because it's powered by community knowledge.</h1>
        </header>
        <ul className="data-notice__list">
          <li>
            Your finished canvas contributes <strong>anonymized structured data</strong> — overall
            grade, layer scores, gap category codes — to a shared benchmarking pool.
          </li>
          <li>
            <strong>No free-text content</strong> is ever shared. Your workflow name, owner name,
            answers, and gap notes stay private.
          </li>
          <li>
            Free users may run <strong>one canvas</strong>. You keep permanent access to that canvas
            and its documents.
          </li>
          <li>
            If you want complete privacy, the Pro plan is <strong>$149/month</strong> — no
            data contribution, unlimited canvases, ongoing coaching.
          </li>
        </ul>
        <div className="data-notice__actions">
          <button className="btn btn--primary btn--large" onClick={onStartFree}>
            Start free
          </button>
          <button className="btn btn--ghost btn--large" onClick={onGoPro}>
            Go Pro — $149/mo
          </button>
        </div>
      </div>
    </div>
  );
}
